<template>
  <div :class="_.block">
    <div :class="[_.hd, _._hairlineBottom]" @click="handleMartClick">
      <img :src="require('./images/店铺.png')" :class="_.icon" />
      <div :class="[_.name, _._ellipsis]">{{ order.merchantName }}</div>
      <van-icon name="arrow" :class="_.arrow" />
    </div>

    <div :class="[_.bd, _._hairlineBottom]">
      <div :class="_.item">
        <div :class="_.main" @click="handleGoodsClick(order)">
          <img :src="order.commodityPic" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.left">
              <div :class="[_.name, _._ellipsis2]">
                {{ order.commodityName }}
              </div>
              <div :class="_.desc">{{ order.skuDesc }}</div>
            </div>
            <div :class="_.right">
              <div :class="_.price">¥{{ order.unitPrice }}</div>
              <div :class="_.count">x{{ order.quantity }}</div>
            </div>
          </div>
        </div>
        <div :class="_.actions"></div>
      </div>
    </div>

    <div :class="[_.ft, isBriefFold && _.fold]">
      <div :class="_.item">
        <div :class="_.label">商品总额</div>
        <div :class="_.value">¥{{ order.orderAmount }}</div>
      </div>
      <div :class="_.item">
        <div :class="_.label">运费</div>
        <div :class="_.value">¥{{ order.postFee }}</div>
      </div>
      <div :class="_.brief" @click="handleBriefClick">
        实付款：
        <div :class="_.price">¥{{ order.payAmount }}</div>
        <van-icon
          :name="isBriefFold ? 'arrow-down' : 'arrow-up'"
          :class="_.arrow"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      isBriefFold: true,
    }),

    methods: {
      handleMartClick() {
        navigateTo('MartIndex', {
          id: this.order.merchantId,
        })
      },

      handleGoodsClick(item) {
        navigateTo('GoodsIndex', {
          id: item.commodityId,
        })
      },

      handleBriefClick() {
        this.isBriefFold = !this.isBriefFold
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    margin-top: 12px;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;
  }

  .hd {
    display: flex;
    align-items: center;
    padding-bottom: 7px;
    overflow: hidden;

    .icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
    }

    .name {
      margin-left: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #222222;
      line-height: 20px;
    }

    .arrow {
      margin-left: 6px;
      flex-shrink: 0;
      font-size: 14px;
      color: #bebebe;
    }
  }

  .bd {
    padding: 12px 0;

    .item {
      .main {
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          object-fit: cover;
        }

        .content {
          flex-grow: 1;
          margin-left: 12px;
          display: flex;

          .left {
            flex-grow: 1;

            .name {
              font-size: 14px;
              color: #222222;
              line-height: 20px;
              word-break: break-all;
            }

            .desc {
              margin-top: 8px;
              font-size: 12px;
              color: #888888;
              line-height: 16px;
            }
          }

          .right {
            flex-shrink: 0;
            width: 90px;
            text-align: right;

            .price {
              font-size: 12px;
              color: #1d1d1c;
              line-height: 17px;
            }

            .count {
              margin-top: 5px;
              font-size: 12px;
              color: #888888;
              line-height: 16px;
            }
          }
        }
      }

      .actions {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .button {
          border-radius: 17px;
          border: 1px solid #aaaaaa;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          padding: 4px 16px;
        }

        &:empty {
          display: none;
        }
      }
    }
  }

  .ft {
    padding-top: 12px;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .label {
        font-size: 14px;
        color: #222222;
        line-height: 20px;
      }

      .value {
        font-size: 14px;
        color: #222222;
        line-height: 20px;

        &.red {
          color: #ff111c;
        }
      }

      &:not(:first-child) {
        margin-top: 12px;
      }
    }

    .brief {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      color: #222222;
      line-height: 20px;

      .price {
        font-size: 16px;
        color: #ff202a;
        font-weight: bold;
        line-height: 22px;
      }

      .arrow {
        margin-left: 8px;
        font-size: 12px;
        color: #222222;
      }
    }

    &.fold {
      .item {
        display: none;
      }

      .brief {
        margin-top: 0;
      }
    }
  }
</style>
